import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export function getTenantBannerConfig(tenantId: number | null, token: string) {
    // If tenantId is null, don't include it in the query string (let backend middleware handle it)
    const url = tenantId ? `${API_URL}/tenant-notices/?tenantId=${tenantId}` : `${API_URL}/tenant-notices/`
    
    return axios.get(url, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
}
export function getTenantUsers(token: string, tenantId: number){
    return axios.get(`${API_URL}/v1/auth0/users/list/?tenantId=${tenantId}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
}